import type {Variants} from 'motion/react';

/**
 * Compass icon (home tab) spins slightly as it becomes active.
 */
const homeIconVariants: Variants = {
    active: {
        rotate: [0, -22, 14, 0],
        transition: {
            duration: 0.5,
            ease: 'easeInOut'
        }
    },
    inactive: {rotate: 0}
};

/**
 * "Opens up" pop-and-settle animation, shared by the map, library, and login tab icons
 * as they become active.
 */
const mapIconVariants: Variants = {
    active: {
        rotate: [-5, 3, 0],
        scale: [0.7, 1.08, 1],
        transition: {
            duration: 0.4,
            ease: 'easeOut'
        }
    },
    inactive: {
        rotate: 0,
        scale: 1
    }
};

/**
 * Question mark icon (FAQ tab) pops into the active indicator circle.
 */
const faqIconVariants: Variants = {
    active: {
        scale: [0.8, 1.25, 0.9, 1],
        transition: {
            duration: 0.45,
            ease: 'easeOut'
        }
    },
    inactive: {scale: 1}
};

/** Fallback for tabs without a dedicated animation. */
export const DEFAULT_NAV_ICON_VARIANTS: Variants = {
    active: {
        scale: [0.85, 1],
        transition: {
            duration: 0.3,
            ease: 'easeOut'
        }
    },
    inactive: {scale: 1}
};

/** Per-tab active-state icon animations, keyed by `NavTab.key`. Library and login reuse the map animation. */
export const NAV_ICON_VARIANTS: Record<string, Variants> = {
    faq: faqIconVariants,
    home: homeIconVariants,
    library: mapIconVariants,
    login: mapIconVariants,
    map: mapIconVariants
};

/** Per-tab transform origin overrides. All icons currently animate around their center. */
export const NAV_ICON_TRANSFORM_ORIGIN: Record<string, string> = {};